import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output
} from "@angular/core";

@Component({
  selector: "app-mic-volume-ui",
  templateUrl: "./mic-volume-ui.component.html",
  styleUrls: ["./mic-volume-ui.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MicVolumeUiComponent {
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();

  onClose() {
    this.close.emit();
  }
}
